import React from "react";

import {rpCommonUrl} from "../../app/read_rp_environment_variables";
import {createOfferLink} from "../helpers/create_offer_link";
import {getOfferTypeNamePlural} from "../helpers/OfferType";
import {IOfferListOffer} from "../types/IOfferListOffer";

interface IProps {
    offers: IOfferListOffer[];
}

export const SchemaListItem = (props: IProps) => {
    const itemListElement = props.offers.map((offer, idx) => {
        const nameValue = `${offer.name} ${offer.region.short_name.split(",").join("")} - ${getOfferTypeNamePlural(offer.type)}${" od " + offer.vendor.name}`;
        const urlValue = `${rpCommonUrl}${createOfferLink(offer)}`;

        return {
            "@type": "ListItem",
            position: idx + 1,
            name: nameValue,
            url: urlValue
        };
    });

    const json = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        itemListElement
    };

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
import React from "react";

import {rpCommonUrl} from "../../app/read_rp_environment_variables";
import {createOfferLink} from "../helpers/create_offer_link";
import {getOfferTypeNamePlural} from "../helpers/OfferType";
import {IOfferListOffer} from "../types/IOfferListOffer";

interface IProps {
    offers: IOfferListOffer[];
}

export const SchemaListItem = (props: IProps) => {
    const itemListElement = props.offers.map((offer, idx) => {
        const nameValue = `${offer.name} ${offer.region.short_name.split(",").join("")} - ${getOfferTypeNamePlural(offer.type)}${" od " + offer.vendor.name}`;
        const urlValue = `${rpCommonUrl}${createOfferLink(offer)}`;

        return {
            "@type": "ListItem",
            position: idx + 1,
            name: nameValue,
            url: urlValue
        };
    });

    const json = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        itemListElement
    };

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
